import { ShieldCheck } from 'lucide-react';
// Read the pack's own palette: importing @shared/constants here would form a cycle through @brand.
import { gradients, rgb } from './palette';

export function LogoMark() {
  return (
    <div
      className="relative grid h-11 w-11 flex-shrink-0 place-items-center rounded-[13px]"
      style={{
        background: gradients.brandPrimary,
        boxShadow: `0 8px 18px rgba(${rgb.brandPrimary},0.3)`,
      }}
    >
      <ShieldCheck className="h-[22px] w-[22px] text-white" strokeWidth={2.4} />
    </div>
  );
}